module.exports = __webpack_public_path__ + "static/img/h5-9.f8a738b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/h5-9.png
// module id = ipAn
// module chunks = 1